export type Colors = {
  black: string
  white: string
  primary: string
  secondary: string
}
export const colors: Colors = {
  primary: '#004175',
  secondary: '#007ce0',
  black: '#000e1a',
  white: '#fffffe'
}

export type Theme = {
  colors: Colors
}
export const theme: Theme = {
  colors
}
